var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErgonomicChairPillow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 90,
    viewBox: "0 0 123 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 41.5V27.5L1.5 26.5L19.5 24L34.5 39L38.5 52.5L69.5 56.5L77.5 76.5L123 45.5V56.5L75.5 90L1 41.5Z",
    fill: "url(#paint0_linear_2_28841)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.03 54.5356L38 52.5L82 22L99.6699 24.2087C108.582 25.3228 116.288 30.9576 120.052 39.1124L123 45.5L77.5 77.5L75.0515 71.0726C71.6342 62.1024 63.5526 55.7448 54.03 54.5356Z",
    fill: "url(#paint1_linear_2_28841)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1916 28.6502L1 27L31.0578 6.45415C37.209 2.24953 44.4863 0 51.9373 0H55.6772C60.3271 0 64.747 2.02289 67.7863 5.54208L82 22L38 52.5L26.6118 35.6014C24.002 31.7287 19.8304 29.1896 15.1916 28.6502Z",
    fill: "url(#paint2_linear_2_28841)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M1 27L14.3385 28.7785C20.1509 29.5534 25.3303 32.8401 28.5067 37.769L38 52.5L50.5252 53.6742C62.3616 54.7839 72.4261 62.7782 76.1855 74.0564L77.5 78L122.5 45.5",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_28841",
    x1: 1.5,
    y1: 36.5,
    x2: 126,
    y2: 54.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.540313,
    stopColor: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3E3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_28841",
    x1: 69.5,
    y1: 33,
    x2: 102.5,
    y2: 60.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_28841",
    x1: 25.5,
    y1: 10,
    x2: 60.5,
    y2: 35.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303030"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErgonomicChairPillow);
export default __webpack_public_path__ + "static/media/ErgonomicChairPillow.c27f3fede528b3df099a151dc9c81146.svg";
export { ForwardRef as ReactComponent };